<template>
  <div>
    <h2 class="flex items-center"><BaseArrowRight class="h-5 mr-2 inline" />{{ heading }}</h2>
    <ul class="border-t border-b border-black mt-3">
      <li v-for="item in items" class="py-3 border-black border-b">
        <router-link :to="getUrl(item)">{{ getTitle(item) }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {

  name: 'Related',

  data () {
    return {

    }
  },

  props: ['heading', 'items'],

  methods: {
    getUrl (item) {
      if (item.type === 'artist') {
        return item.url
      } else if (item.type === 'event_child') {
        return `/calendar/${item.date}/${item.slug}`
      } else {
        return '/'
      }
    },
    getTitle (item) {
      const title = this.getFieldByLang(item, 'title', this.$store.state.lang)
      if (item.type === 'artist') {
        return title
      } else if (item.type === 'event_child') {
        return `${item.date}: ${title}`
      }
    }
  }
}
</script>

<style lang="css" scoped>
  li:last-child {
    border: none;
  }

  a {
    border: none;
  }
</style>
